import { FC } from "react";
import Grid from "@mui/material/Grid2";
import AddSection from "./AddSection.tsx";
import PostAdd from "@mui/icons-material/PostAdd";
import HelpButton from "../base/HelpButton.tsx";
import Collections from "@mui/icons-material/Collections";
import OndemandVideo from "@mui/icons-material/OndemandVideo";
import Audiotrack from "@mui/icons-material/Audiotrack";
import {Plan} from "@memaro/api";

export type AddSectionButtonGridProps = {
    plan: Plan
    onAddText: () => void,
    onAddPhotoCarousel: () => void,
    onAddVideo: () => void,
    onAddAudio: () => void,
}

const AddSectionButtonGrid: FC<AddSectionButtonGridProps> = ({
    plan,
    onAddText,
    onAddPhotoCarousel,
    onAddAudio,
    onAddVideo
}) => (
    <Grid container spacing={2} sx={{marginTop: '10px'}}>
        <Grid size={6} sx={{position: 'relative'}}>
            <AddSection icon={<PostAdd/>} label="Tekstblok toevoegen" onClick={onAddText}/>
            <HelpButton
                help="Tekstblokken kunnen gebruikt worden om een verhaal te vertellen, herinneringen te delen of andere teksten toe te voegen die belangrijk zijn voor de overledene."
                absolutePosition
            />
        </Grid>
        <Grid size={6} sx={{position: 'relative'}}>
            <AddSection icon={<Collections/>} label="Foto carousel toevoegen" onClick={onAddPhotoCarousel}/>
            <HelpButton
                help="Foto carrousels kunnen gebruikt worden om een verzameling van foto's te tonen, zoals een galerij van herinneringen of belangrijke momenten in het leven van de overledene."
                absolutePosition
            />
        </Grid>
        {plan != Plan.Bronze ? (
            <>
                <Grid size={6} sx={{position: 'relative'}}>
                    <AddSection icon={<OndemandVideo/>} label="Video toevoegen" onClick={onAddVideo}/>
                    <HelpButton
                        help="Video's kunnen gebruikt worden om een boodschap achter te laten, een herinnering te delen of andere belangrijke video's toe te voegen die relevant zijn voor de overledene."
                        absolutePosition
                    />
                </Grid>
                <Grid size={6} sx={{position: 'relative'}}>
                    <AddSection icon={<Audiotrack/>} label="Audio toevoegen" onClick={onAddAudio}/>
                    <HelpButton
                        help="Audio kan gebruikt worden om een boodschap achter te laten, een herinnering te delen of andere belangrijke audiofragmenten toe te voegen die relevant zijn voor de overledene."
                        absolutePosition
                    />
                </Grid>
            </>
        ) : null}
    </Grid>
)


export default AddSectionButtonGrid;
